export const NAME = 'monetico';

export const SET_MONETICO_FORMDATA = 'SET_MONETICO_FORMDATA';

export const REQUEST_MONETICO_FORMDATA = 'REQUEST_MONETICO_FORMDATA';
export const RECEIVE_MONETICO_FORMDATA = 'RECEIVE_MONETICO_FORMDATA';
export const FAILURE_MONETICO_FORMDATA = 'FAILURE_MONETICO_FORMDATA';

export const REQUEST_PAYMENT = 'REQUEST_PAYMENT';


// WEBPACK FOOTER //
// ./src/services/monetico/constants.js